import { computed, watch } from 'vue'

import { injectWizard } from '@/composables/useWizardContext'
import { storeSettings } from '@/config/agentWizardSteps'

// Which object a store step edits: the shared section, or one store's own settings in a sub-step.
export const useStoreStepTarget = (stepKey, storeIdRef) => {
  const wizard = injectWizard()
  const section = wizard.data[stepKey]

  const subStore = computed(() => {
    if (!storeIdRef.value || !section.per_store) return null
    return wizard.stores.value.find(store => String(store.id) === storeIdRef.value) ?? null
  })

  // A sub-step edits its own entry, created from the shared values the first time it is shown.
  watch(
    subStore,
    store => {
      const id = store && String(store.id)
      if (id && !section.stores[id]) section.stores[id] = { ...storeSettings(wizard.data, stepKey, id) }
    },
    { immediate: true }
  )

  const target = computed(() => (subStore.value ? section.stores[String(subStore.value.id)] : section))

  // Customised per store, the shared page only picks stores: the settings live in each store's sub-step.
  const showFields = computed(() => Boolean(subStore.value) || !section.per_store || wizard.ctx.storeCount < 2)

  return { wizard, section, subStore, target, showFields }
}
